import type { Image } from "#/types/types";

type HospitalProfileHeaderProps = {
  coverImage: Image | null;
  logoImage: Image | null;
  title: string | null;
};

const HiringOrgHeader: React.FC<HospitalProfileHeaderProps> = ({
  coverImage,
  logoImage,
  title,
}) => {
  return (
    <div className="relative">
      <div className="h-64 w-full bg-gray-200">
        <img
          src={coverImage?.url}
          alt={coverImage?.alt}
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute bottom-0 left-0 right-0 top-0 flex items-end bg-gradient-to-t from-black to-transparent p-4">
        <div className="flex items-center">
          <div className="aspect-square h-24 w-24 w-24 min-w-24 grow overflow-hidden rounded-full border-4 border-white bg-white shadow-lg">
            <img
              src={logoImage?.url}
              alt={logoImage?.alt}
              className="h-full w-full object-cover"
            />
          </div>
          <div className="ml-4 flex text-white">
            <h1 className="text-wrap text-2xl font-bold">{title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiringOrgHeader;
